export const emailRegex: RegExp = /^[^@]+@[^@]+\.[^@]+$/;

export const organizationNumberRegex: RegExp = /[8-9][0-9]{8}/;

export const postalCodeRegex: RegExp = /^\d{4}$/;

export const guidRegex: RegExp = /[0-9A-Fa-f]{8}-([0-9A-Fa-f]{4}-){3}[0-9A-Fa-f]{12}/;
